import { useState } from 'react';
import { useContentPartnersQuery } from 'services/api/creativeServer';
import { Option } from '../types';

export const useContentPartnerSearch = () => {
  const [contentSearchKeyword, setContentSearchKeyword] = useState('');

  const {
    data: contentPartnersData,
    isFetching: isContentPartnerFetching,
    isLoading: isContentPartnerLoading,
  } = useContentPartnersQuery(
    {
      keyword: contentSearchKeyword,
    },
    { skip: contentSearchKeyword.trim().length === 0 },
  );

  const loadContentOptions = (
    inputValue: string,
    callback: (options: Option[]) => void,
  ) => {
    setContentSearchKeyword(inputValue);

    if (!inputValue) {
      callback([]);
      return;
    }
    if (contentPartnersData) {
      const options = contentPartnersData.map(content => ({
        value: content,
        label: content,
      }));
      callback(options);
    } else {
      callback([]);
    }
  };

  return {
    loadContentOptions,
    isContentPartnerFetching,
    isContentPartnerLoading,
  };
};
